import React, { useContext, useEffect, useState } from "react";
import Filter from "../components/common/Filter";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import DiscountedProduct from "../components/common/DiscountedProduct";
import Products from "../components/common/Products";
import { useFormik } from "formik";
import ReactSlackChat from "react-slack-chat";
import { Helmet } from "react-helmet";
import { useSearchParams } from "react-router-dom";
import Storys from "../components/common/mobile/Storys";
import { FilterContext } from "../context/FilterContext";
import Modal from "@mui/material/Modal";
import { FaTimes } from "react-icons/fa";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "#fff",
  boxShadow: 24,
  borderRadius: 10,
  minWidth: 300,
};

const HomePage = ({ dealerData }) => {
  const [show, setShow] = useState(false);
  const formik = useFormik({
    initialValues: {
      year_start: "",
      year_end: "",
      min_price: "",
      max_price: "",
      min_tonaj: "",
      max_tonaj: "",
      category: "",
      haveImg: "",
      onFire: "",
      search_key: "",
      search_type: "product",
    },
  });

  const filterData = useContext(FilterContext);

  const {
    setfilter_category,
    setfilter_year_start,
    setfilter_year_end,
    setfilter_min_price,
    setfilter_max_price,
    setfilter_min_tonaj,
    setfilter_max_tonaj,
    setfilter_haveImg,
    setfilter_onFire,
    setfilter_search_key,
    filter_category,
    setfilter_search_type,
  } = filterData;

  useEffect(() => {
    formik.setFieldValue("category", filter_category);
  }, [filter_category]);

  async function handleSubmit(e) {
    e?.preventDefault();

    setfilter_year_start(formik.values.year_start);
    setfilter_year_end(formik.values.year_end);
    setfilter_min_price(formik.values.min_price);
    setfilter_max_price(formik.values.max_price);
    setfilter_min_tonaj(formik.values.min_tonaj);
    setfilter_max_tonaj(formik.values.max_tonaj);
    setfilter_category(formik.values.category);
    setfilter_haveImg(formik.values.haveImg);
    setfilter_onFire(formik.values.onFire);
    setfilter_search_key(formik.values.search_key);
    setfilter_search_type(formik.values.search_type);
  }

  return (
    <div className="grid grid-cols-4 gap-8 w-full container_1 py-8">
      {show && (
        <Modal
          open={show}
          onClose={() => setShow(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div dir="rtl" className="outline-none" style={style}>
            <div className="p-4 flex flex-col gap-2">
              <h3 className="font-bold mb-2 flex justify-between items-center">
                نوع جستجو{" "}
                <FaTimes
                  color="#000"
                  onClick={() => setShow(false)}
                  className="cursor-pointer"
                  size={16}
                />
              </h3>
              <span className="flex justify-between">
                <span className="text-[#2E3132] text-[16px] font-[500]">
                  اسم محصول
                </span>
                <label class="inline-flex items-center cursor-pointer relative">
                  <input
                    type="radio"
                    name="product"
                    class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-gray-600 text-gray-900 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-8 before:w-8 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:before:bg-gray-900 hover:before:opacity-10"
                    id="product"
                    checked={formik.values.search_type === "product"}
                    onClick={(e) =>
                      formik.setFieldValue("search_type", "product")
                    }
                  />
                  <span class="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
                    </svg>
                  </span>
                </label>
              </span>
              <span className="flex justify-between">
                <span className="text-[#2E3132] text-[16px] font-[500]">
                  شماره محصول
                </span>
                <label class="inline-flex items-center cursor-pointer relative">
                  <input
                    type="radio"
                    name="product_number"
                    id="product_number"
                    class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none rounded-full border border-gray-600 text-gray-900 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-8 before:w-8 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-gray-900 checked:before:bg-gray-900 hover:before:opacity-40"
                    checked={formik.values.search_type === "product_number"}
                    onClick={(e) =>
                      formik.setFieldValue("search_type", "product_number")
                    }
                  />
                  <span class="absolute text-gray-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <circle data-name="ellipse" cx="8" cy="8" r="8"></circle>
                    </svg>
                  </span>
                </label>
              </span>
            </div>
          </div>
        </Modal>
      )}
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"مرکز خرید و فروش ماشین های سنگین"}</title>
        <meta name="description" content={"مرکز خرید و فروش ماشین های سنگین"} />
        <meta name="keywords" content={""} />
        <meta
          name="og:description"
          content={"مرکز خرید و فروش ماشین های سنگین"}
        />
        <meta name="og:title" content={"مرکز خرید و فروش ماشین های سنگین"} />
      </Helmet>{" "}
      <span className="col-span-full">
        <Storys desktop dealerData={dealerData} />
      </span>
      <span className="col-span-full">
        <RequestBuy />
      </span>
      <span className="col-span-full">
        <DiscountedProduct />
      </span>
      <span className="col-span-1">
        <Filter
          handleSubmit={handleSubmit}
          formik={formik}
          dealerData={dealerData}
        />
      </span>
      <span className="col-span-3 pt-4 flex flex-col gap-4">
        <span className="relative w-full">
          <form onSubmit={handleSubmit}>
            <input
              className="w-full form-brand xl:min-w-[210px] h-[58px]"
              placeholder="مثلا: فوتون 460"
              id="search_key"
              name="search_key"
              value={formik.values.search_key}
              onChange={formik.handleChange}
            />
          </form>

          <p className="on-border font-bold">جستجو</p>
          <img
            src="/Filter.png"
            alt="filter"
            className="absolute translate-y-[-50%] top-[50%] left-4 cursor-pointer"
            onClick={() => setShow(true)}
          />
          {/* <img
            src="/Filter2.png"
            alt="filter"
            className="absolute translate-y-[-50%] top-[50%] left-8"
          /> */}
        </span>
        <Products />
        <div dangerouslySetInnerHTML={{ __html: dealerData?.homeText }} />
      </span>
    </div>
  );
};

export default HomePage;
